export default "__VITE_ASSET__BnjRWk5Y__"